/***记录订单组件**/
<template>
  <div class="recordOrderMod" @click="actionFn">
    <div class="ListItem">
      <div class="itemContent">
        <div class="item-row">
          <div class="itemTime">酒后代驾</div>
          <div class="itemStatus">
            <i class="iconfont icon-jiantou" v-if="status.status !== 40"></i>
            <span class="text "
                  :class="status.name === '新单' ? 'textRed':status.name === 5||status.name === 6?'textAsh':''">
                  {{status.name}}
            </span>
          </div>
        </div>
        <div class="item-time">
          <i class="iconfont icon-shijian1"></i>
          <span class="site">{{serverTime}}</span>
        </div>
        <div class="item-address">
          <i class="yuan"></i>
          <span class="site">{{startAddress}}</span>
        </div>
        <div class="item-address">
          <i class="yuan color-red"></i>
          <span class="site">{{endAddress}}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  //  import Toucth from '../../../../assets/js/method'

  export default {
    name: 'xk-recordOrderMod',
    props: ['startAddress', 'endAddress', 'serverTime', 'status', 'orderId', 'router'],
    computed: {},
    data () {
      return {}
    },
    methods: {
      actionFn: function () {
        let router = this.$props.status.router
        if (router) {
          if (this.$props.status.status !== 40) {
            this.$router.push({path: router.path, query: router.query})
          }
        }
      }
    },
    mounted: function () {
      console.log(this.$props.status)
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style rel="stylesheet/less" lang="less">
  .recordOrderMod {
    .ListItem {
      box-sizing: border-box;
      width: calc(~'100% - 1rem');
      margin: 1rem 0.5rem;
      padding: 12px;
      background-color: #fff;
      border-radius: 0.33333rem;
      overflow: hidden;
      .itemContent {
        .item-title{
          font-size:14px;
          font-weight:500;
          color:rgba(34,34,34,1);
          line-height:20px;
        }
        .item-row{
          height: 20px;
          line-height: 20px;
          margin-bottom: 12px;
          .itemTime {
            float: left;
            display: inline-block;
            font-size: 1rem;
            color: #333;
          }
          .itemStatus {
            float: right;
            display: inline-block;
            .text {
              float: right;
              color: #333;
              margin-right: 0.5rem;
            }
            .textRed {
              color: #f06553;
            }
            .textAsh {
              color: #999999;
            }
          }
          i {
            font-size: 0.8333rem;
            color: #999999;
            float: right;
          }
        }
        .item-time{
          font-size:13px;
          font-weight:400;
          color:rgba(102,102,102,1);
          line-height:18px;
          margin-bottom: 8px;
          .icon-shijian1{
            font-size: 8px;
          }
        }
        .item-address{
          font-size:13px;
          font-weight:400;
          color:rgba(102,102,102,1);
          height: 18px;
          line-height:18px;
          display: flex;
          justify-content: start;
          align-items: center;
          .yuan{
            display: block;
            width: 6px;
            height: 6px;
            background-color: #FFA000;
            border-radius: 50%;
            margin-right: 8px;
          }
          .site{
            display: block;
            line-height:18px;
          }
        }
        .item-address+.item-address{
          margin-top: 2px;
        }
        .color-red{
          background-color: #FF6577!important;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// recordOrderMod.vue?29ab3448